"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var _default = /*#__PURE__*/_react["default"].createElement("svg", {
  width: "12",
  height: "14",
  viewBox: "0 0 12 14"
}, /*#__PURE__*/_react["default"].createElement("path", {
  d: "M8.68 13.92c4.4-1.57 2.74-8.74 1.09-9.78-.12.56-.7 1.59-2.02 1.25C8.16 3.26 6.68.4 5.57 0c-.17.72-.36 2.2-3.1 4.97-4.96 5.01 1 9.67 1.16 8.95.15-.73-.11-1.16 1.14-2.48.82-.87 1.1-1.78 1.32-2.53V8.9c1.86.94 2.59 3.98 2.59 5.02z"
}));

exports["default"] = _default;